"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Vrati query part obaleny OR podminkou.
 *
 * @param {Array} parts
 *
 * @returns {Object}
 */
var orToQuery = function orToQuery(parts) {
  return !Array.isArray(parts) || parts.length === 0 ? undefined : {
    $or: parts
  };
};

var _default = orToQuery;
exports.default = _default;